<template>
  <div class="container" style="overflow-y: hidden;">
    <searchModal
      :closeSearchModal="closeSearchModal"
      v-if="searchModalOpen"
    ></searchModal>
    <!-- toolbar -->
    <div
      class="search-top-city-container"
      id="sticky-search-bar"
    >
      <div
        class="toolbar-content-container pos-rel"
        v-if="$store.state.common.isModeSwipe != true"
      >
        <div style="flex-grow: 1">
          <a
            href="https://www.withaview.co"
            class="go-back-icon-and-fullscreen-mobile"
          >
            <label>{{ filterViewType }}</label>
            <div class="logo">
              <img
                src="/static/img/icons/wav-logo.png"
                alt="logo"
                height="30px"
              />
            </div>
          </a>
        </div>
        <div class="list-view-text" style="cursor: pointer">
          <a href="https://www.withaview.co" class="text-decoration-none">
            <img
              src="/static/img/icons/wav-logo.png"
              class="hidden-md-and-up mt-2"
              height="24px"
          /></a>
          <searchContainer />
        </div>
        <div class="header-section-3">
          <div
            style="display: flex; flex-direction: column"
            @click="
              isLoggedIn
                ? $router.push({
                    path: '/profile',
                    query: {
                      profile_Id: user.uid,
                      selected_tab: 'checkins',
                    },
                  })
                : $router.push(`/login`)
            "
          >
            <div class="pill-container">
              <div class="pill pointer" style="color: #b6b6b6; flex-grow: 1">
                <i class="material-icons">note_add</i>
              </div>
              <div style="border: 0.5px solid #b6b6b6; width: 1px"></div>
              <div
                class="pill pointer"
              >
                <i
                  class="material-icons"
                  v-if="!isLoggedIn && this.screenW < 600"
                  >account_circle</i
                >
                <i
                  class="material-icons"
                  v-if="!isLoggedIn && this.screenW > 600"
                  >perm_identity</i
                >
                <img
                  :src="this.$store.state.auth.user.photoURL"
                  v-if="isLoggedIn"
                  style="height: 1.75rem; width: 1.75rem; border-radius: 100%"
                />
              </div>
            </div>
            <div class="pills-description">
              <label class="description-item pointer"  @click="
              isLoggedIn
                ? $router.push({
                    path: '/profile',
                    query: {
                      profile_Id: user.uid,
                      selected_tab: 'checkins',
                    },
                  })
                : $router.push(`/login`)
            ">Travel list</label>
              <label class="description-item pointer"  
              @click="
                  isLoggedIn
                    ? $router.push({
                        path: '/profile',
                        query: {
                          profile_Id: user.uid,
                          selected_tab: 'checkins',
                        },
                      })
                    : $router.push(`/login`)
                ">Profile</label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- toolbar ends -->

    <!--- animation down arrow for scroll indication only (for desktop) (dispaly nonoe)--->
    <div
      class="arrow-container"
      v-if="showScrollArrow && !$store.state.common.isModeSwipe"
    >
      <div class="arrow-down"></div>
    </div>
    <!--- animation arrow ends --->

    <!-- fullscreen or list view-->
    <!-- fullscreen footer : fullscreen icon left bottom -->
    <div v-if="$store.state.common.isModeSwipe && filteredImagesArr.length > 0">
      <div v-if="!showOnboardings">
        <div
          id="fade-foot"
          class="footer-container-main mobile-expand-icon"
          style="z-index: 100"
        >
          <div class="footer-container-new blurred-bg">
            <!-- fullscreen icon actions-->
            <div class="actions">
              <div class="like-share-fullscreen-container">
                <div class="fullscreen-box" @click="isSwipeZoom = !isSwipeZoom">
                  <i
                    :style="isSwipeZoom ? 'color: rgb(254, 189, 53)' : ''"
                    class="material-icons"
                    style="font-size: 1.8em"
                    >{{ isSwipeZoom ? "zoom_out_map" : "fullscreen_exit" }}</i
                  >
                </div>
              </div>
              <div class="swipe-up-arrow"></div>
            </div>
            <!-- fullscreen icon actions end -->
          </div>
        </div>
      </div>
    </div>
    <!-- fullscreen footer : fullscreen icon left bottom ends-->

    <!-- fullscreen footer : share, like and add to travel list -->
    <div v-if="$store.state.common.isModeSwipe && filteredImagesArr.length > 0">
      <div v-if="!showOnboardings">
        <div
          id="fade-foot"
          class="footer-container-main mobile-side-icons"
          style="z-index: 100"
        >
          <div class="footer-container-new blurred-bg">
            <!-- footer actions -->
            <div class="actions">
              <div class="swipe-up-arrow"></div>
              <div>
                <!-- share action -->
                <i
                  @click="
                    share(
                      filteredImagesArr[swipeIndex].id,
                      filteredImagesArr[swipeIndex].caption === ''
                        ? 'n'
                        : filteredImagesArr[swipeIndex].caption
                    )
                  "
                  class="material-icons flip-reply-icon mb-3 ml-1"
                  >reply</i
                >
                <!-- share action ends -->

                <!-- image like action-->
                <div
                  @click="changeCnt()"
                  style="
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    margin-bottom: 23px;
                  "
                >
                  <div
                    :style="{
                      visibility: `${
                        filteredImagesArr[swipeIndex].likes === 0
                          ? 'hidden'
                          : 'visible'
                      }`,
                    }"
                  >
                    {{ filteredImagesArr[swipeIndex].likes }}
                  </div>
                  <i
                    class="material-icons mobile_like"
                    :style="
                      filteredImagesArr[swipeIndex].isLiked
                        ? 'color:#ff0000'
                        : 'color:#ffffff'
                    "
                    >{{
                      filteredImagesArr[swipeIndex].isLiked
                        ? "favorite"
                        : "favorite_outline"
                    }}</i
                  >
                </div>
                <!-- image like action ends -->

                <!-- add to travel list action-->
                <div @click="changeCntCheckin()" class="want-to-go-button">
                  {{
                    filteredImagesArr[swipeIndex].isCheckedin
                      ? ""
                      : `${
                          filteredImagesArr[swipeIndex].checkins !== 0
                            ? filteredImagesArr[swipeIndex].checkins
                            : ""
                        }`
                  }}
                  <i
                    class="material-icons"
                    :style="
                      !filteredImagesArr[swipeIndex].isCheckedin
                        ? 'color: white; backgroundColor:#bd10e0;'
                        : ''
                    "
                    >{{
                      filteredImagesArr[swipeIndex].isCheckedin
                        ? "check"
                        : "add"
                    }}</i
                  >
                </div>
                <!-- add to travel list action ends -->
              </div>
            </div>
            <!-- footer actions ends -->
          </div>
        </div>
      </div>
    </div>
    <!-- fullscreen footer : share, like and add to travel list ends -->

    <!-- fullscreen mode or list view mode -->
    <div
      class="fullscreen-container-main pos-fixed"
      :class="`blur-it-${$store.state.common.swichModesBG}`"
      style="width: 100%"
    >
      <div>
        <!-- bouncing arrow and text for fullscreen mode in mobile -->
        <div
          v-show="hideOnBoardingOn.indexOf(swipeIndex) === -1"
          id="arrow_down"
          v-if="swipeIndex < 2 && $store.state.common.isModeSwipe"
          style="position: fixed; z-index: 10000000; width: 100%; top: 48%"
        >
          <div v-if="_isFirstVisit">
            <div class="swipe-arrow-text" v-html="swipeArrowText"></div>
            <i class="fa style-icon bounce" :class="swipeArrowIcon"></i>
          </div>
        </div>
        <!-- bouncing arrow and text ends -->

        <div class="fullscreen-container pos-rel">
          <!-- show if fullscreen mode -->
          <div
            v-if="$store.state.common.isModeSwipe"
            class="pos-rel swipe-container"
          >
            <v-layout
              v-touch="{
                left: function () {},
                right: function () {},
                up: function () {
                  increment();
                },
                down: function () {
                  decrement();
                },
              }"
              @touchend="easeOut(1)"
              column
              align-center
              justify-center
              id="layout-swipe"
              style="overflow-y: hidden; height: 100vh"
              class="grey lighten-2"
            >
              <div
                :style="
                  isSwipeZoom
                    ? 'display: flex; background: black'
                    : { width: `${screenW}px`, height: `${screenH}px` }
                "
              >
                <img
                  class="left-right-hand-swipe"
                  src="../../static/img/left-right-hand-swipe-white.png"
                  v-if="
                    getSwipeCount() == 1 ||
                    (getSwipeCount() == 3 && $store.state.common.isModeSwipe)
                  "
                />
                <span
                  class="gesture-text-swipe-sides"
                  v-if="
                    getSwipeCount() == 1 ||
                    (getSwipeCount() == 3 && $store.state.common.isModeSwipe)
                  "
                >
                  Swipe left and right
                  <br />to see the complete image
                </span>
                <img
                  @click="increment"
                  class="long-up-arrow"
                  src="../../static/img/long-up-arrow-white.svg"
                  v-if="
                    getSwipeCount() == 0 ||
                    (getSwipeCount() == 2 && $store.state.common.isModeSwipe)
                  "
                />
                <span
                  @click="increment"
                  class="gesture-text-swipe-up"
                  v-if="
                    getSwipeCount() == 0 ||
                    (getSwipeCount() == 2 && $store.state.common.isModeSwipe)
                  "
                  >Swipe up for the next view</span
                >
                <div
                  class="city-spotType"
                  @click="
                    $router.push({ path: '/filter', query: $route.query })
                  "
                >
                  <label class="loc-name"
                    >{{ getCity(filteredImagesArr[swipeIndex]) }} |</label
                  >
                  <label
                    class="spot-name"
                    :style="
                      getSpotType(filteredImagesArr[swipeIndex]) == 'Spot'
                        ? 'opacity: 0.7'
                        : 'opacity: 1'
                    "
                    >{{ getSpotType(filteredImagesArr[swipeIndex]) }}</label
                  >
                </div>
                <span
                  @click="increment"
                  class="tap-for-details"
                  v-if="getSwipeCount() == 4 && $store.state.common.isModeSwipe"
                  >Tap anywhere for details</span
                >
                <img
                  v-if="filteredImagesArr.length != 0"
                  @click="imageClick($event, filteredImagesArr[swipeIndex])"
                  :src="
                    fullscreenImage(
                      filteredImagesArr[swipeIndex].id,
                      filteredImagesArr[swipeIndex]
                    )
                  "
                  :style="
                    isSwipeZoom
                      ? `width: ${screenW}px; object-fit: contain`
                      : `height:${screenH}px`
                  "
                  :id="`element-${swipeIndex}`"
                  alt="image"
                />
              </div>
            </v-layout>
            <div>
              <div style="position: relative">
                <div
                  :id="`swipe-ele-black-inc-${swipeIndex}`"
                  style="
                    top: -100vh;
                    position: fixed;
                    height: 100vh;
                    width: 100vw;
                    background-color: #313131;
                    opacity: 0.9;
                    z-index: 3;
                    visibility: hidden;
                    left: 0;
                  "
                ></div>
                <div
                  :id="`swipe-ele-image-inc-${swipeIndex}`"
                  style="
                    top: -100vh;
                    position: fixed;
                    height: 100vh;
                    width: 100vw;
                    background-color: #313131;
                    z-index: 2;
                    visibility: hidden;
                    left: 0;
                  "
                >
                  <p class="current-page">{{ currentPage }}</p>
                </div>
              </div>
            </div>

            <!-- ON DOWN SWIPE -->
            <div>
              <div style="position: relative">
                <div
                  :id="`swipe-ele-black-${swipeIndex}`"
                  style="
                    left: 0;
                    bottom: -100vh;
                    position: fixed;
                    height: 100vh;
                    width: 100vw;
                    background-color: #313131;
                    opacity: 0.4;
                    z-index: 3;
                    visibility: hidden;
                  "
                ></div>
                <div
                  :id="`swipe-ele-image-${swipeIndex}`"
                  style="
                    left: 0;
                    bottom: -100vh;
                    position: fixed;
                    height: 100vh;
                    width: 100vw;
                    background-color: #313131;
                    z-index: 2;
                    visibility: hidden;
                  "
                >
                  <p class="current-page">{{ currentPage }}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- show if fullscreen mode ends -->

          <!-- show if scroll view or list iew -->
          <div
            @scroll="getScrollPos"
            class="img-cont pos-rel touch"
            v-else
            id="layout-scroll"
          >
            <div
              v-if="filteredImagesArr.length != 0"
              class="list-view-images-container"
            >
              <div
                v-for="(image, imageIndex) in filteredImagesArr"
                :key="imageIndex"
                @mouseover="updateSwipeIndex(imageIndex)"
                @touchstart="updateSwipeIndex(imageIndex)"
                class="relative-img touch"
                :id="`scroll${imageIndex}`"
                :ref="`scroll${imageIndex}`"
              >
                <div class="list-view-image-container">
                  <div class="card-top hidden-md-and-up">
                    <label class="image-caption">{{ image.caption }} in </label>
                    <!-- location details -->
                    <div class="location-details">
                      <label
                        class="spot-name pointer"
                        :style="
                          getSpotType(image) == 'Spot'
                            ? 'opacity: 0.7'
                            : 'opacity : 1'
                        "
                        >{{ getSpotType(image) }}</label
                      >
                      <label class="loc-name pointer"
                        >{{ getCity(image) }},
                        {{ image.aboutLoc.country }}</label
                      >
                    </div>
                    <!-- /location details -->
                  </div>
                  <div
                    class="d-flex"
                    style="
                      position: relative;
                      z-index: 11;
                      height: 100%;
                      overflow: hidden;
                    "
                  >
                    <a
                      style="width: 75%; border-radius: 12px; overflow: hidden"
                      :href="currentDomain + '/id/' + image.id + '?inapp=true'"
                    >
                      <v-lazy-image
                        :src="listviewImage(image.id, image)"
                        class="fullscreen-image"
                        style="width: 100%; min-height: 100%"
                      />
                    </a>
                    <!-- Desktop section for image details -->
                    <div class="hidden-sm-and-down image-details-desktop">
                      <div>
                        <label class="image-caption">{{ image.caption }}</label>
                        <!-- location details -->
                        <div class="image-location">
                          <label
                            class="spot-name"
                            :style="
                              getSpotType(image) == 'Spot'
                                ? 'opacity: 0.7'
                                : 'opacity : 1'
                            "
                            >{{ getSpotType(image) }} in
                          </label>
                          <label class="loc-name"
                            >{{ getCity(image) }},
                            {{ image.aboutLoc.country }}</label
                          >
                        </div>
                        <br/>
                        <a class="details-btn p-3 pointer" :href="currentDomain + '/id/' + image.id + '?inapp=true'" :target="target">
                          <label class="pointer">Details</label>
                        </a>
                      </div>
                      <div class="footer-container-desktop">
                        <div class="photograher-likes-share">
                          <div class="photographer-container">
                            <!-- photographer name -->
                            <div
                              :style="
                                image.uploader === 'admin'
                                  ? { color: '#b9b9b9' }
                                  : { cursor: 'pointer' }
                              "
                              class="photographer"
                              @click="
                                image.uploader !== 'admin' ? saveInLs() : '';
                                image.uploader !== 'admin'
                                  ? $router.push({
                                      path: '/profile',
                                      query: {
                                        uploader: image.uploader,
                                        profile_id:
                                          image.mediaSourceInformation
                                            .photoGrapherId,
                                        selected_tab: 'checkins',
                                      },
                                    })
                                  : '';
                              "
                            >
                              <img
                                v-if="image.uploader !== 'admin'"
                                :src="
                                  image.mediaSourceInformation.photoGrapherPic
                                "
                                @click="
                                  image.uploader !== 'admin'
                                    ? $router.push(
                                        `/profile?selected_tab=checkins&profile_id=${top_sectionArr[current_top_index].mediaSourceInformation.photoGrapherId}`
                                      )
                                    : ''
                                "
                                alt="profile-photo"
                              />
                              {{
                                cropUsername(
                                  image.mediaSourceInformation.photoGrapherName
                                )
                              }}
                              ©
                            </div>
                            <!-- /photographer name -->
                          </div>
                          <div style="display: flex; align-items: center">
                            <!-- likes -->
                            <div
                              class="likes"
                              style="
                                display: flex;
                                align-items: center;
                                height: fit-content;
                              "
                            >
                              <i
                                class="material-icons"
                                style="font-size: 1.403em; margin-left: 5px"
                                :style="{
                                  color: `${
                                    image.isLiked ? '#ff0000' : '#ffffff'
                                  }`,
                                  opacity: `${image.isLiked ? '1' : '0.5'}`,
                                }"
                                @click="changeCnt()"
                                >{{
                                  image.isLiked
                                    ? "favorite"
                                    : "favorite_outline"
                                }}</i
                              >
                            </div>
                            <!-- /likes -->

                            <!-- share -->
                            <i
                              @click="
                                share(
                                  image.id,
                                  image.caption === '' ? 'n' : image.caption
                                )
                              "
                              class="
                                white--text
                                material-icons
                                pointer
                                flip-reply-icon
                              "
                              >reply</i
                            >
                            <!--/share-->
                          </div>
                        </div>
                        <div class="location-and-travel-list">
                          <!-- save to travel list -->
                          <div class="want-scroll">
                            <a
                              :href="image.propertyLink"
                              target="_blank"
                              v-if="image.propertyLink && tab === 'hotel'"
                              class="check-prices mr-1"
                            >
                              Check Price
                            </a>
                            <button
                              :class="
                                image.isCheckedin
                                  ? 'on-travel-list'
                                  : 'want-to-go-button-scroll'
                              "
                              @click="changeCntCheckin()"
                            >
                              <i
                                class="material-icons mr-2"
                                :style="
                                  !image.isCheckedin
                                    ? 'color: white;font-size: 1.5rem;'
                                    : 'font-size: 1.8em;color: #febd35'
                                "
                                >{{ image.isCheckedin ? "check" : "add" }}</i
                              >
                              {{
                                image.isCheckedin
                                  ? "On travel list"
                                  : "Save to travel list"
                              }}
                            </button>
                          </div>
                          <!-- /save to travel list -->
                        </div>
                      </div>
                    </div>
                    <div class="container-over-image hidden-md-and-up">
                      <!-- likes -->
                      <div
                        class="likes"
                        style="
                          display: flex;
                          align-items: center;
                          height: fit-content;
                        "
                      >
                        <span class="icon-container mr-3">
                          <i
                            class="material-icons"
                            style="margin-top: 1px"
                            :style="{
                              color: `${image.isLiked ? '#ff0000' : '#ffffff'}`,
                            }"
                            @click.stop="changeCnt()"
                            >{{
                              image.isLiked ? "favorite" : "favorite_outline"
                            }}</i
                          >
                        </span>
                      </div>
                      <!-- /likes -->

                      <!-- share -->
                      <span class="icon-container">
                        <img
                          src="static/img/ic-reply.svg"
                          height="24px"
                          @click.stop="
                            share(
                              image.id,
                              image.caption === '' ? 'n' : image.caption
                            )
                          "
                        />
                      </span>
                      <!--/share-->
                    </div>
                  </div>
                  <!-- image footer -->
                  <div class="icons-footer-2 hidden-md-and-up">
                    <div class="footer-container">
                      <div class="location-and-travel-list">
                        <div class="image-details-mobile">
                          <label
                            class="image-caption"
                            @click="imageDet(image, imageIndex)"
                            >{{ image.caption }}</label
                          >
                          <!-- location details -->
                          <div
                            class="location-details"
                            @click="imageDet(image, imageIndex)"
                          >
                            <label
                              class="spot-name pointer"
                              :style="
                                getSpotType(image) == 'Spot'
                                  ? 'opacity: 0.7'
                                  : 'opacity : 1'
                              "
                              >{{ getSpotType(image) }}</label
                            >
                            <label class="loc-name pointer"
                              >in {{ getCity(image) }},
                              {{ image.aboutLoc.country }}</label
                            >
                          </div>
                          <!-- /location details -->
                          <!-- photographer name -->
                          <div
                            :style="
                              image.uploader === 'admin'
                                ? { color: '#b9b9b9' }
                                : { cursor: 'pointer' }
                            "
                            class="photographer"
                            @click.stop="
                              image.uploader !== 'admin' ? saveInLs() : '';
                              image.uploader !== 'admin'
                                ? $router.push({
                                    path: '/profile',
                                    query: {
                                      uploader: image.uploader,
                                      profile_id:
                                        image.mediaSourceInformation
                                          .photoGrapherId,
                                      selected_tab: 'checkins',
                                    },
                                  })
                                : '';
                            "
                          >
                            <img
                              v-if="
                                image.mediaSourceInformation.photoGrapherPic !==
                                'http://cdn.onlinewebfonts.com/svg/img_191958.png'
                              "
                              :src="
                                image.mediaSourceInformation.photoGrapherPic
                              "
                              @click="
                                image.uploader !== 'admin'
                                  ? $router.push(
                                      `/profile?selected_tab=checkins&profile_id=${top_sectionArr[current_top_index].mediaSourceInformation.photoGrapherId}`
                                    )
                                  : ''
                              "
                              alt="profile-photo"
                            />
                            {{
                              cropUsername(
                                image.mediaSourceInformation.photoGrapherName
                              )
                            }}
                            ©
                          </div>
                          <!-- /photographer name -->
                        </div>
                        <!-- save to travel list -->
                        <div class="want-scroll">
                          <a
                            :href="image.propertyLink"
                            target="_blank"
                            v-if="image.propertyLink && tab === 'hotel'"
                            class="check-prices mr-1"
                          >
                            Check Price
                          </a>
                          <button
                            :class="
                              image.isCheckedin
                                ? 'on-travel-list'
                                : 'want-to-go-button-scroll'
                            "
                            @click="changeCntCheckin()"
                          >
                            <i
                              class="material-icons"
                              :style="
                                !image.isCheckedin
                                  ? 'color: white;font-size: 1.8em;'
                                  : 'font-size: 1.8em;color: #febd35'
                              "
                              v-if="!image.propertyLink"
                              >{{ image.isCheckedin ? "check" : "add" }}</i
                            >
                            {{
                              image.isCheckedin
                                ? "On travel list"
                                : "Save to travel list"
                            }}
                          </button>
                        </div>
                        <!-- /save to travel list -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="
                filteredImagesArr.length == 0 &&
                this.selectedCity !== 'worldwide' &&
                this.selectedCity !== undefined
              "
              class="no-photos"
            >
              <label
                >No Photos Available for the current location filter.</label
              >
              <!-- <button
                @click="$router.push({ path: '/filter', query: $route.query })"
                class="filters-page"
              >
                Go to Filters page
              </button> -->
            </div>
          </div>
          <!-- scroll view or list view ends -->
        </div>
      </div>
    </div>

    <!-- sticky footer-->
    <bottom-navigation
      localStorageName="homePageImages"
      :screenH="screenH"
      :screenW="screenW"
      view="list"
      :maxPhotos="filteredImagesArr.length"
      :swipeIndex="swipeIndex"
      :isModeSwipe="this.$store.state.common.isModeSwipe"
      :lastSelectedQuery="this.$route.query.loc"
      :filteredImagesArr="filteredImagesArr"
      :isLoggedIn="this.$store.state.auth.isLoggedIn"
      :user="this.$store.state.auth.user"
      :setSwipeIndex="setSwipeIndex"
      :showModeNavigation="true"
    />
    <!-- sticky footer ends-->
  </div>
</template>

<script>
import imageLinks from "../mixin/imageLinks";
import cropUsername from "../mixin/cropUsername";

import { mapMutations, mapGetters } from "vuex";
import { ele } from "@/helper/gen";
//
import { identifyOS, identifyDesktop, isChrome } from "../helper/identifyOS";
import share_m from "../mixin/share";
import bottomNavigation from "../components/common/bottomNavigation.vue";
import searchModal from "../components/homepage/searchModal.vue";
import searchContainer from "../components/common/searchContainer.vue";
import configurations from "../configurations";
//
let vm;
export default {
  components: { bottomNavigation, searchModal, searchContainer },
  metaInfo() {
    return {
      title: "with a view",
    };
  },
  filters: {
    getName: function () {
      let str = vm === undefined ? "" : vm.selectedCity;
      if (str.length > 20) {
        let s = str.substring(0, 20);
        return `${s}...`;
      } else {
        return str;
      }
    },
  },
  mixins: [share_m, imageLinks, cropUsername],
  data() {
    return {
      showNoMorePhotoSlackBar: true,
      windowInnerHeight: window.innerHeight,
      isSwipeZoom: false,
      appDelay: 0.1,
      appSwipeTime: 1,
      onBoardingData: [], //onBoarding,
      showOnboardings: false,
      currentOnBoardImageIndex: 0,
      delay: 0.1, // 0
      swipeTime: 1, // 0
      swipeArrowIcon: "fa-arrow-up",
      swipeArrowText: "",
      selectedCity: "Berlin",
      //
      isDeviceIOS: false,
      visitedIndexes: [0],
      currentPage: 0,
      showSwipeLoader: false,
      none: "prev",
      prevImgIndex: false,
      screenH: 0,
      showCarousel: true,
      isEventDoubleClick: false,
      changeAdmire: false,
      admireMode: true,
      screenW: 0,
      swipeIndex: 0,
      swipeCount: null,
      tapped: false,
      totalScrollImageHeight: 0,
      hideOnBoardingOn: [],
      isFirstTimeOn1: true,
      //
      os: null,
      desktop: null,
      browser: null,
      clickDelay: 600,
      clicks: 0,
      timer: null,
      showScrollArrow: true,
      scrollId: null,
      //
      filterLocation: "Anywhere",
      filterViewType: "Everything is better ",
      //
      currentDomain: configurations.currentDomain,
      searchModalOpen: false,
      tab: "",
      showNavbar: true,
      lastScrollPosition: 0,
      target: "_blank"
    };
  },
  //
  watch: {
    "$store.state.gen.finalUserLocation": () => {
      vm.getLocation();
    },
    //
    "$route.query": () => {
      vm.$store.state.hello.filteredImagesArr = [];
      vm.totalScrollImageHeight = 0;
      let obj = JSON.parse(JSON.stringify(vm.$route.query));
      vm.tab = obj.tab ? obj.tab : "all";
      console.log("ACTIVE TAB", vm.tab);
      if (localStorage.getItem("_p") !== null) {
        if (obj.loc.toLowerCase() === `worldwide`) {
          vm.$store.commit(`getElsewherePics`, {
            limit: vm.limit,
            startAt: 0,
            emotionalAppeal:
              obj.emotionalAppeal === undefined ? ["all"] : obj.emotionalAppeal,
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType:
              obj.st === undefined
                ? ["all"]
                : Array.isArray(obj.st)
                ? obj.st
                : [obj.st],
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.srt,
            userGeo: obj.userGeo,
          });
        } else {
          // OLD FUNC, BERLIN.
          vm.$store.commit(`getMainScreenImages`, {
            query: JSON.stringify({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: vm.limit,
            uid: vm.$store.state.auth.user.uid,
            isLoggedIn: vm.$store.state.auth.isLoggedIn,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType:
              obj.st === undefined
                ? ["all"]
                : Array.isArray(obj.st)
                ? obj.st
                : [obj.st],
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.sortBy,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo,
          });
        }
      }
      if (obj.filter) {
        if (obj.loc.toLowerCase() === `worldwide`) {
          vm.$store.commit(`getElsewherePics`, {
            limit: vm.limit,
            startAt: 0,
            emotionalAppeal:
              obj.emotionalAppeal === undefined ? ["all"] : obj.emotionalAppeal,
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : obj.st,
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.srt,
            userGeo: obj.userGeo,
          });
        } else {
          // OLD FUNC, BERLIN.
          vm.$store.commit(`getMainScreenImages`, {
            query: JSON.stringify({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: vm.limit,
            uid: vm.$store.state.auth.user.uid,
            isLoggedIn: vm.$store.state.auth.isLoggedIn,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType: obj.st === undefined ? ["all"] : obj.st,
            viewType: obj.vt === undefined ? [] : [obj.vt],
            sortBy: obj.sortBy,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo,
          });
        }
      }
    },
    //
    "$store.state.common.isModeSwipe": () => {
      vm.totalScrollImageHeight = 0;
      localStorage.setItem(
        "MODE",
        JSON.stringify(vm.$store.state.common.isModeSwipe)
      );
      if (!vm.$store.state.common.isModeSwipe) {
        setTimeout(() => {
          document.getElementsByClassName("img-cont")[0].style.width =
            vm.screenW + "px";
        }, 200);
      }
    },
    swipeIndex: function () {
      //
      setTimeout(() => {
        if (this.swipeIndex === 4) {
          this.swipeArrowText = "";
          this.swipeArrowIcon = "";
        } else if (this.swipeIndex === 0) {
          this.swipeArrowText = ``;
          this.swipeArrowIcon = "fa-arrow-up";
        }
      }, 1000);
      //
      if (
        this.visitedIndexes[this.visitedIndexes.length - 1] < this.swipeIndex
      ) {
        this.visitedIndexes.push(this.swipeIndex);
        this.visitedIndexes.sort();
        if (
          this.swipeIndex === this.filteredImagesArr.length - 1 &&
          localStorage.getItem("homePageImages") === null
        ) {
          // console.log(
          //   "IN IF ie. => this.swipeIndex == (this.startAt + this.limit - 1) is true"
          // );
          // CALL API
          //
          let obj = JSON.parse(JSON.stringify(vm.$route.query));
          if (this.$route.query.loc.toLowerCase() !== `worldwide`) {
            this.$store.commit(`getMainScreenImages`, {
              query: JSON.stringify({ testamp: ["testberlin"] }),
              startAt: this.filteredImagesArr.length,
              limit: vm.limit,
              uid: vm.$store.state.auth.user.uid,
              isLoggedIn: vm.$store.state.auth.isLoggedIn,
              emotionalAppeal:
                obj.emotionalAppeal === undefined
                  ? ["all"]
                  : [obj.emotionalAppeal],
              keywords: obj.keywords === undefined ? ["extabs"] : obj.keywords,
              spotType: obj.st === undefined ? ["all"] : obj.st,
              viewType: obj.vt === undefined ? ["all"] : obj.vt,
              sortBy: obj.srt,
              addressIndex: [obj.loc],
              userGeo: obj.userGeo,
            });
          } else {
            vm.$store.commit(`getElsewherePics`, {
              limit: this.limit,
              startAt: this.filteredImagesArr.length,
              emotionalAppeal:
                obj.emotionalAppeal === undefined
                  ? ["all"]
                  : [obj.emotionalAppeal],
              keywords:
                obj.keywords === undefined ? ["extabs"] : [obj.keywords],
              spotType:
                obj.st === undefined
                  ? ["all"]
                  : Array.isArray(obj.st)
                  ? obj.st
                  : [obj.st],
              viewType: obj.vt === undefined ? [] : [obj.vt],
              sortBy: obj.srt,
              userGeo: obj.userGeo,
            });
          }
        } else {
          localStorage.removeItem("homePageImages");
        }
      }
      //
      // CHECK TO REMOVE ON BOARDING...
      if (this.swipeIndex === 1) {
        if (this.isFirstTimeOn1) {
          // DO NOTHING
        } else {
          if (this.hideOnBoardingOn.indexOf(1) === -1) {
            this.hideOnBoardingOn.push(1);
          }
          this.$forceUpdate();
        }
        //
        this.isFirstTimeOn1 = false;
        if (this.hideOnBoardingOn.indexOf(0) === -1) {
          this.hideOnBoardingOn.push(0);
        }
      }
      //
    },
    //
    selectedCity: () => {
      if (vm.selectedCity === undefined) {
        vm.$router.push({
          path: `/`,
          query: {
            loc: `worldwide`,
          },
        });
        vm.selectedCity = `worldwide`;
      } else {
        let obj = Object.assign({}, vm.$route.query);
        obj.loc = vm.selectedCity;
        vm.$router.push({
          path: `/`,
          query: obj,
        });
      }
    },
    currentOnBoardImageIndex: {
      handler() {
        if (this.currentOnBoardImageIndex === 5) {
          setTimeout(() => {
            if (ele("berlin-viewzzz") != null) {
              document
                .getElementById("berlin-viewzzz")
                .addEventListener("click", () => {
                  this.incrementApp();
                });
              document
                .getElementById("berlin-viewzzz-2")
                .addEventListener("click", () => {
                  this.incrementApp();
                });
            }
          }, 40);
          //
        }
      },
    },
    //
  },
  methods: {
    ...mapMutations([
      "goToImageDetMap",
      "goTo_uploadImage",
      "fadeOpen",
      "getMainScreenImages",
      "operationOnPhoto",
      "getLocation",
      "snackbar_alert",
    ]),
    closeSearchModal() {
      this.searchModalOpen = false;
    },
    openSearchModal() {
      this.searchModalOpen = true;
    },
    onScroll(pos) {
      if (pos > 500) {
        if(pos - this.lastScrollPosition < 0){
          document.getElementById("sticky-search-bar").style.top= '0px';
        }else{
          document.getElementById("sticky-search-bar").style.top = '-100%';
        }
        this.lastScrollPosition = pos;
      }else{
        document.getElementById("sticky-search-bar").style.top = '0px';
      }
    },
    getImageClasses(imageIndex) {
      if (imageIndex == 0) {
        return "relative-img touch first-image";
      } else if (imageIndex == this.filteredImagesArr.length - 1) {
        return "relative-img touch last-image";
      } else {
        return "relative-img touch ";
      }
    },
    goToUpload() {
      if (this.$store.state.auth.isLoggedIn) {
        this.$router.push("/upload-0");
      } else {
        this.$router.push("/login");
        this.$store.commit("snackbar_alert", {
          msg: "Please sign-in to complete this action. It takes only a few seconds.",
        });
      }
    },
    saveMode() {
      localStorage.setItem("MODE", this.$store.state.common.isModeSwipe);
    },
    getScrollPos() {
      let elem = ele(`layout-scroll`);
      let containerScrollPos = elem.scrollTop;
      this.onScroll(containerScrollPos);
      let containerScrollHeight = elem.scrollHeight;
      if (
        containerScrollPos >= containerScrollHeight - 1000 &&
        !this.$store.state.hello.fetchingImagesFromDb &&
        this.$store.state.hello.fetchedPicsLength >
          this.$store.state.hello.limit
      ) {
        let obj = JSON.parse(JSON.stringify(vm.$route.query));
        if (obj.srt) {
          if (obj.srt === "ts") {
            obj.srt = "createdAt";
          } else if (obj.srt === "lks") {
            obj.srt = "likes";
          } else if (obj.srt === "km") {
            obj.srt = "distance";
          } else {
            obj.srt = obj.srt;
          }
        }

        if (vm.$route.query.loc.toLowerCase() === `worldwide`) {
          vm.$store.commit(`getElsewherePics`, {
            limit: vm.limit,
            startAt: this.filteredImagesArr.length,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType:
              obj.st === undefined
                ? ["all"]
                : Array.isArray(obj.st)
                ? obj.st
                : [obj.st],
            viewType: obj.vt === undefined ? ["all"] : [obj.vt],
            sortBy: obj.srt,
            userGeo: obj.userGeo,
          });
        } else {
          // OLD FUNC, BERLIN.
          vm.$store.commit(`getMainScreenImages`, {
            query: JSON.stringify({ testamp: ["testberlin"] }),
            startAt: this.filteredImagesArr.length,
            limit: vm.limit,
            uid: vm.$store.state.auth.user.uid,
            isLoggedIn: vm.$store.state.auth.isLoggedIn,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType:
              obj.st === undefined
                ? ["all"]
                : Array.isArray(obj.st)
                ? obj.st
                : [obj.st],
            sortBy: obj.srt,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo,
          });
        }
      }
      if (containerScrollPos > 4 * screen.height) {
        this.showScrollArrow = false;
      }
    },

    // ONBOARDINGS
    decrementApp() {
      if (vm.currentOnBoardImageIndex !== 0) {
        this.none = "prev";
        let pos = ele(`layout-swipe-app`).scrollLeft;
        let elemB = ele(`swipe-ele-black-${vm.currentOnBoardImageIndex}-app`);
        let elemI = ele(`swipe-ele-image-${vm.currentOnBoardImageIndex}-app`);
        elemI.style.backgroundImage = `url(${
          vm.onBoardingData[vm.currentOnBoardImageIndex].image
        })`;
        elemI.style.backgroundSize = `cover`;
        elemI.style.backgroundSize = `auto ${vm.screenH}px`;
        elemI.style.backgroundPositionX = `-${pos}px`;
        elemI.style.backgroundRepeat = `no-repeat`;
        setTimeout(() => {
          this.currentPage = vm.currentOnBoardImageIndex;
          elemB.style.visibility = "visible";
          elemI.style.visibility = "visible";
          TweenMax.from(elemB, vm.delay, {
            opacity: 0,
            onComplete: () => {
              vm.showSwipeLoader = true;
              if (vm.currentOnBoardImageIndex === 0) {
              } else {
                vm.currentOnBoardImageIndex--;
              }
              elemB.style.opacity = 0.99;
              TweenMax.from(elemB, vm.swipeTime, {
                bottom: 0,
                delay: vm.delay,
                opacity: 0.6,
              });
              TweenMax.from(".current-page", vm.delay, { y: -420, opacity: 0 });
              TweenMax.from(elemI, vm.swipeTime, {
                bottom: 0,
                delay: vm.delay,
                onComplete: () => {
                  elemB.style.visibility = "hidden";
                  elemI.style.visibility = "hidden";
                },
              });
            },
          });
        }, 10);
      }
    },

    incrementApp() {
      if (vm.currentOnBoardImageIndex < 6) {
        this.none = "next";
        let pos = ele(`layout-swipe-app`).scrollLeft;
        let elemBN = ele(
          `swipe-ele-black-inc-${vm.currentOnBoardImageIndex}-app`
        );
        let elemIN = ele(
          `swipe-ele-image-inc-${vm.currentOnBoardImageIndex}-app`
        );
        elemIN.style.backgroundImage = `url(${
          vm.onBoardingData[vm.currentOnBoardImageIndex].image
        })`;
        elemIN.style.backgroundSize = `cover`;
        elemIN.style.minWidth = `${vm.screenW}px`;
        elemIN.style.backgroundSize = `auto ${vm.screenH}px`;
        elemIN.style.backgroundSize = `auto ${vm.screenH}px`;
        elemIN.style.backgroundPositionX = `-${pos}px`;
        elemIN.style.backgroundRepeat = `no-repeat`;
        setTimeout(() => {
          this.currentPage = vm.currentOnBoardImageIndex + 1;
          elemBN.style.visibility = "visible";
          elemIN.style.visibility = "visible";
          TweenMax.from(elemBN, vm.delay, {
            opacity: 0,
            onComplete: () => {
              vm.showSwipeLoader = true;
              if (vm.currentOnBoardImageIndex === 5) {
                vm.showOnboardings = false;
              } else {
                vm.currentOnBoardImageIndex++;
              }
              elemBN.style.opacity = 0.99;
              TweenMax.from(elemBN, vm.swipeTime, {
                top: 0,
                delay: vm.delay,
                opacity: 0.6,
              });
              TweenMax.from(".current-page", vm.delay, {
                y: 420,
                opacity: 0.6,
              });
              TweenMax.from(elemIN, vm.swipeTime, {
                top: 0,
                delay: vm.delay,
                onComplete: () => {
                  elemBN.style.visibility = "hidden";
                  elemIN.style.visibility = "hidden";
                },
              });
            },
          });
        }, 10);
      }
    },

    recenterImageApp() {
      ele("layout-swipe-app").scrollLeft = 0;
      this.easeOutApp(100);
    },
    easeOutApp(time) {
      setTimeout(() => {
        let currentScrollPosition = ele(`layout-swipe-app`).scrollLeft;
        let upperLimit =
          ele(`element-${vm.currentOnBoardImageIndex}-app`).clientWidth -
          vm.screenW;
        let lowerLimit = 0;
        let scrollWidth = upperLimit / 2;
        if (
          currentScrollPosition >= upperLimit - 10 ||
          currentScrollPosition <= lowerLimit + 10
        ) {
          TweenMax.to("#layout-swipe-app", 1, {
            scrollLeft: scrollWidth,
            ease: Bounce.easeOut,
          });
        }
      }, time);
    },
    imageDet(image, index) {
      if (event.ctrlKey) {
        localStorage.setItem("scrollId", "scroll" + index);
        this.saveInLs();
      } else {
        localStorage.setItem("scrollId", "scroll" + index);
        this.$router.push({
          path: `/id/${image.id}?inapp=true`,
        });
        this.saveInLs();
      }
    },
    imageClick(event, image) {
      this.clicks++;
      let self = this;
      if (self.clicks === 1) {
        self.timer = setTimeout(function () {
          self.imageDet(image);
          self.clicks = 0;
        }, self.clickDelay);
      } else {
        clearTimeout(this.timer);
        self.changeCnt();
        self.clicks = 0;
      }
    },
    changeMode() {
      setTimeout(() => {
        if (this.screenW < 600) {
          this.$store.state.common.isModeSwipe = true;
        } else {
          this.getScroll(0);
        }
      }, 300);
    },
    setSwipeIndex() {
      this.swipeIndex = 0;
    },
    noMorePhotos() {
      if (
        !this.morePhotos &&
        this.swipeIndex == this.maxPhotos - 1 &&
        this.showNoMorePhotoSlackBar
      ) {
        this.showNoMorePhotoSlackBar = false;
        this.$store.commit(`snackbar_alert`, {
          msg: `No more spots...`,
        });
      }
    },
    recenterImage() {
      ele("layout-swipe").scrollLeft = 0;
      this.easeOut(100);
    },
    increment() {
      if (!this.isSwipeZoom) {
        if (vm.swipeIndex != vm.maxPhotos - 1) {
          this.none = "next";
          let elemBN = ele(`swipe-ele-black-inc-${vm.swipeIndex}`);
          let elemIN = ele(`swipe-ele-image-inc-${vm.swipeIndex}`);
          elemIN.style.backgroundImage = `url(${vm.fullscreenImage(
            vm.filteredImagesArr[vm.swipeIndex].id,
            vm.filteredImagesArr[vm.swipeIndex]
          )})`;
          elemIN.style.backgroundSize = `cover`;
          elemIN.style.minWidth = `${vm.screenW}px`;
          setTimeout(() => {
            this.currentPage = vm.swipeIndex + 1;
            elemBN.style.visibility = "visible";
            elemIN.style.visibility = "visible";
            TweenMax.from(elemBN, vm.delay, {
              opacity: 0,
              onComplete: () => {
                vm.showSwipeLoader = true;
                if (vm.swipeIndex === vm.maxPhotos && vm.swipeIndex !== 0) {
                } else {
                  vm.swipeIndex++;
                  sessionStorage.setItem(
                    "swipeCount",
                    Number(sessionStorage.getItem("swipeCount")) + 1
                  );
                }
                elemBN.style.opacity = 0.99;
                TweenMax.from(elemBN, vm.swipeTime, {
                  top: 0,
                  delay: vm.delay,
                  opacity: 0.6,
                });
                TweenMax.from(".current-page", vm.delay, {
                  y: 420,
                  opacity: 0,
                });
                TweenMax.from(elemIN, vm.swipeTime, {
                  top: 0,
                  delay: vm.delay,
                  onComplete: () => {
                    elemBN.style.visibility = "hidden";
                    elemIN.style.visibility = "hidden";
                  },
                });
              },
            });
          }, 10);
        }
      } else {
        if (vm.swipeIndex === vm.maxPhotos) {
        } else {
          vm.swipeIndex++;
          sessionStorage.setItem(
            "swipeCount",
            Number(sessionStorage.getItem("swipeCount")) + 1
          );
        }
      }

      this.noMorePhotos();
    },
    decrement() {
      if (!this.isSwipeZoom) {
        if (vm.swipeIndex !== 0) {
          this.none = "prev";
          let pos =
            ele(`layout-swipe`) !== null ? ele(`layout-swipe`).scrollLeft : 0;
          let elemB = ele(`swipe-ele-black-${vm.swipeIndex}`);
          let elemI = ele(`swipe-ele-image-${vm.swipeIndex}`);
          elemI.style.backgroundImage = `url(${vm.fullscreenImage(
            vm.filteredImagesArr[vm.swipeIndex].id,
            vm.filteredImagesArr[vm.swipeIndex]
          )})`;
          elemI.style.backgroundSize = `cover`;
          elemI.style.backgroundSize = `auto ${vm.screenH}px`;
          elemI.style.backgroundPositionX = `-${pos}px`;
          elemI.style.backgroundRepeat = `no-repeat`;
          setTimeout(() => {
            this.currentPage = vm.swipeIndex;
            elemB.style.visibility = "visible";
            elemI.style.visibility = "visible";
            TweenMax.from(elemB, vm.delay, {
              opacity: 0,
              onComplete: () => {
                vm.showSwipeLoader = true;
                if (vm.swipeIndex === 0) {
                } else {
                  vm.swipeIndex--;
                }
                elemB.style.opacity = 0.99;
                TweenMax.from(elemB, vm.swipeTime, {
                  bottom: 0,
                  delay: vm.delay,
                  opacity: 0.6,
                });
                TweenMax.from(".current-page", vm.delay, {
                  y: -420,
                  opacity: 0,
                });
                TweenMax.from(elemI, vm.swipeTime, {
                  bottom: 0,
                  delay: vm.delay,
                  onComplete: () => {
                    elemB.style.visibility = "hidden";
                    elemI.style.visibility = "hidden";
                  },
                });
              },
            });
          }, 10);
        }
      } else {
        if (vm.swipeIndex === 0) {
        } else {
          vm.swipeIndex--;
        }
      }
    },
    easeOut(time) {
      setTimeout(() => {
        let currentScrollPosition =
          ele(`layout-swipe`) !== null ? ele(`layout-swipe`).scrollLeft : 0;
        if (ele(`element-${vm.swipeIndex}`) !== null) {
          let upperLimit =
            ele(`element-${vm.swipeIndex}`).clientWidth - vm.screenW;
          let lowerLimit = 0;
          let scrollWidth = upperLimit / 2;
          if (
            currentScrollPosition >= upperLimit - 10 ||
            currentScrollPosition <= lowerLimit + 10
          ) {
            TweenMax.to("#layout-swipe", 1, {
              scrollLeft: scrollWidth,
              ease: Bounce.easeOut,
            });
          }
        }
      }, time);
    },

    //for scroll
    getScroll(index) {
      if (index < this.maxPhotos - 1) {
        let cont = ele(`scroll${index + 1}`);
        let position = cont.scrollLeft;
        position = 0;
        position += 200;
        cont.scrollLeft = position;
      } else {
        this.noMorePhotos();
      }
    },
    async changeCnt(isanimate = false) {
      if (!this.$store.state.gen.isAPICalling) {
        let img = vm.filteredImagesArr[vm.swipeIndex];
        if (this.isLoggedIn) {
          if (img.isLiked === false) {
            img.isLiked = true;
            img.likes++;
          } else {
            img.isLiked = false;
            img.likes--;
          }
          this.$store.commit("UPDATE_IS_API_CALLING", { val: true });
          let status = await vm.$store.dispatch("operationOnPhoto", {
            pid: img.id,
            uid: vm.user.uid,
            operation: "like",
            uploaderId: img.mediaSourceInformation.photoGrapherId,
            action: img.isLiked ? "add" : "remove",
          });
          this.$store.commit("UPDATE_IS_API_CALLING", { val: false });
          this.$forceUpdate();

          if (isanimate) {
            TweenMax.to("#wishlist-btn", 0.5, {
              visibility: `visible`,
              opacity: 0.95,
            });
            TweenMax.from("#wishlist-btn", 0.5, {
              visibility: `visible`,
              opacity: 0.95,
              delay: 0.7,
            });
          }
        } else {
          this.$store.commit("snackbar_alert", {
            msg: " Please sign in to complete your desired action.",
          });
          this.$router.push({ path: "/login" });
        }
      }
    },
    async changeCntCheckin() {
      if (!this.$store.state.gen.isAPICalling) {
        let img = vm.filteredImagesArr[vm.swipeIndex];
        if (this.isLoggedIn) {
          if (img.isCheckedin === false) {
            img.isCheckedin = true;
            img.checkins++;
          } else {
            img.isCheckedin = false;
            img.checkins--;
          }
          this.$store.commit("UPDATE_IS_API_CALLING", { val: true });
          let status = await vm.$store.dispatch("operationOnPhoto", {
            pid: img.id,
            uid: vm.user.uid,
            operation: "checkin",
            uploaderId: img.mediaSourceInformation.photoGrapherId,
            action: img.isCheckedin ? "add" : "remove",
          });
          this.$store.commit("UPDATE_IS_API_CALLING", { val: false });
          this.$forceUpdate();
        } else {
          this.$store.commit("snackbar_alert", {
            msg: "Please sign-in to like it. It takes only a few seconds.",
          });
          this.$router.push({ path: "/login" });
        }
      }
    },

    // CHECK FOR DBL TAP TO ADD IN WISHLIST
    dblTabPhone() {
      if (this.isLoggedIn) {
        if (this.tapped === false) {
          this.tapped = true;
          let tapTimer = setTimeout(() => {
            vm.tapped = false;
          }, 300);
        } else {
          this.isEventDoubleClick = true;
          this.myFunction();
        }
      }
    },
    saveInLs() {
      let localStorageItem = {
        maxPhotos: this.filteredImagesArr.length,
        swipeIndex: this.swipeIndex,
        filteredImagesArr: this.filteredImagesArr,
        isModeSwipe: this.$store.state.common.isModeSwipe,
        lastSelectedQuery: this.$route.query.loc,
      };
      localStorage.setItem("homePageImages", JSON.stringify(localStorageItem));
    },

    // ADD TO WISHLIST FUNCTION HERE
    myFunction() {
      if (!this.filteredImagesArr[vm.swipeIndex].isLiked) {
        this.changeCnt(true);
      }
    },

    // UPDATES THE SWIPE INDEX IN SCROLL MODE
    updateSwipeIndex(index) {
      this.swipeIndex = index;
      this.getScroll(index);
    },

    // TOGGLES BETWEEN SCROLL AND SWIPE MODE
    toggleSwipe() {
      setTimeout(() => {
        if (this.screenW < 601) {
          this.$store.state.common.isModeSwipe =
            !this.$store.state.common.isModeSwipe;
          this.$forceUpdate();

          if (!vm.$store.state.common.isModeSwipe) {
            setTimeout(() => {
              ele(`scroll${vm.swipeIndex}`).scrollIntoView();
              vm.getScroll(vm.swipeIndex);
            }, 100);
          } else {
            vm.easeOut(1);
          }
        }
      }, 300);
    },
    checkIfFilterArrFilled() {
      if (this.filteredImagesArr.length === 0) {
        setTimeout(() => {
          this.checkIfFilterArrFilled();
        }, 300);
      }
    },
    getSpotType(filterArr) {
      let defaultSpotType = "Spot";
      if (filterArr != undefined) {
        if (filterArr.spotType.length == 0) {
          return defaultSpotType;
        } else {
          if (
            filterArr.spotType.length == 1 &&
            filterArr.spotType[0] == "all"
          ) {
            return defaultSpotType;
          } else {
            let priorityList = [
              "rooftop bar",
              "bar",
              "airbnb",
              "apartment",
              "hotel room",
              "room",
              "hotel",
              "infinity pool",
              "pool",
              "restaurant",
              "cafe",
            ];
            let spotType = defaultSpotType;
            let i;
            for (i = 0; i < priorityList.length; i++) {
              if (filterArr.spotType.includes(priorityList[i])) {
                spotType = priorityList[i];
                break;
              }
            }
            return this.getCapitalizedString(spotType);
          }
        }
      } else {
        return defaultSpotType;
      }
    },
    getCapitalizedString(str) {
      if (str) {
        let capitalizedString = str.charAt(0).toUpperCase() + str.slice(1);
        return capitalizedString;
      } else {
        return "";
      }
    },
    getCity(filterArr) {
      if (filterArr != undefined) {
        let city_or_country = "";
        if (filterArr.aboutLoc.city != undefined) {
          city_or_country = filterArr.aboutLoc.city;
        } else if (filterArr.aboutLoc.state != undefined) {
          city_or_country = filterArr.aboutLoc.state;
        } else if (filterArr.aboutLoc.subLocality != undefined) {
          city_or_country = filterArr.aboutLoc.subLocality;
        } else {
          city_or_country = filterArr.aboutLoc.country;
        }
        return this.getCapitalizedString(city_or_country);
      } else {
        return "City/Country";
      }
      return obj;
    },
    getSwipeCount() {
      return sessionStorage.getItem("swipeCount");
    },
  },
  computed: {
    ...mapGetters([
      "startAt",
      "limit",
      "filteredImagesArr",
      "maxPhotos",
      "user",
      "fetchLocLoader",
      "isLoggedIn",
      "_isFirstVisit",
      "fetchedPicsLength",
      "morePhotos",
    ]),
    getWindowInnerHeight() {
      return window.innerHeight;
    },
    getToShowFilter() {
      let obj = {
        filterVal: "Filter",
      };
      let _routes = JSON.parse(JSON.stringify(vm.$route.query));
      if (Object.keys(_routes).length > 1) {
        for (let i in _routes) {
          if (
            i !== "loc" &&
            i !== "sortBy" &&
            i !== "createdAt" &&
            i !== "userGeo"
          ) {
            obj.filterVal = _routes[i];
          }
        }
      }
      return obj;
    },
    getWidthOfSelOnBasisOfSelCity() {
      if (vm.selectedCity === `Berlin`) {
        return "4.7";
      } else if (vm.selectedCity === `worldwide`) {
        return "6.7";
      }
    },
  },
  created() {
    vm = this;
    let scount = sessionStorage.getItem("swipeCount");
    if (scount == undefined) {
      sessionStorage.setItem("swipeCount", 0);
    } else if (scount < 2) {
      sessionStorage.setItem("swipeCount", 0);
    } else {
      //NOTHING
    }
    let obj = JSON.parse(JSON.stringify(vm.$route.query));
    vm.filterViewType = obj.viewType ? obj.viewType : "Everything is better";
    vm.filterLocation =
      obj.loc && obj.loc !== "Worldwide" ? obj.loc : "Anywhere";
    setTimeout(() => {
      if (this.screenW < 600 && this.$route.query.view === "list") {
        this.$store.state.common.isModeSwipe = false;
        this.$store.state.common.swichModesBG = false;
      } else {
      }
      vm.selectedCity = !!this.$route.query.loc
        ? this.$route.query.loc.toLowerCase()
        : "worldwide";
      if (
        this.$route.query.loc.toLowerCase() === `worldwide` ||
        this.$route.query.loc === undefined
      ) {
        let obj = JSON.parse(JSON.stringify(vm.$route.query));
        if (obj.srt) {
          if (obj.srt === "ts") {
            obj.srt = "createdAt";
          } else if (obj.srt === "lks") {
            obj.srt = "likes";
          } else if (obj.srt === "km") {
            obj.srt = "distance";
          } else {
            obj.srt = obj.srt;
          }
        }
        vm.$store.commit(`getElsewherePics`, {
          limit: this.limit,
          startAt: 0,
          emotionalAppeal:
            obj.emotionalAppeal === undefined ? ["all"] : [obj.emotionalAppeal],
          keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
          spotType:
            obj.st === undefined
              ? ["all"]
              : Array.isArray(obj.st)
              ? obj.st
              : [obj.st],
          viewType: obj.vt === undefined ? [] : [obj.vt],
          sortBy: obj.srt,
          userGeo: obj.userGeo,
        });
      } else {
        // BERLIN
        if (localStorage.getItem("homePageImages") == null) {
          let obj = JSON.parse(JSON.stringify(vm.$route.query));
          if (obj.srt) {
            if (obj.srt === "ts") {
              obj.srt = "createdAt";
            } else if (obj.srt === "lks") {
              obj.srt = "likes";
            } else if (obj.srt === "km") {
              obj.srt = "distance";
            } else {
              obj.srt = obj.srt;
            }
          }
          this.$store.commit(`getMainScreenImages`, {
            query: JSON.stringify({ testamp: ["testberlin"] }),
            startAt: 0,
            limit: this.limit,
            uid: this.$store.state.auth.user.uid,
            isLoggedIn: this.$store.state.auth.isLoggedIn,
            emotionalAppeal:
              obj.emotionalAppeal === undefined
                ? ["all"]
                : [obj.emotionalAppeal],
            keywords: obj.keywords === undefined ? ["extabs"] : [obj.keywords],
            spotType:
              obj.st === undefined
                ? ["all"]
                : Array.isArray(obj.st)
                ? obj.st
                : [obj.st],
            sortBy: obj.srt,
            addressIndex: [vm.$route.query.loc],
            userGeo: obj.userGeo,
          });
        }
      }
    }, 10);
    // }
  },

  mounted() {
    //set target type
    if(this.screenW <=768){
      this.target="_self"
    }
    //gets the query object
    let obj = JSON.parse(JSON.stringify(vm.$route.query));
    vm.tab = obj.tab ? obj.tab : "all";
    this.$store.state.hello.filteredImagesArr = [];
    //
    //code regarding the fullscreen mode
    if (localStorage.getItem("showOnboard") === null && screen.width < 600) {
      localStorage.setItem("showOnboard", JSON.stringify(false));
      this.showOnboardings = false;
      for (let i in this.onBoardingData) {
        let img = new Image();
        img.src = this.onBoardingData[i].image;
      }
    } else {
      this.showOnboardings = false; //TRUE//
    }
    if (screen.width < 768) {
      this.showScrollArrow = false;
    }
    this.$store.commit("getLocationFinal");
    window.helloThis = this;
    this.checkIfFilterArrFilled();
    this.isDeviceIOS =
      !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    if (!this.isDeviceIOS) {
      this.screenH = screen.height;
      this.screenW = screen.width;
      if (this.screenW > 600) {
        this.$store.state.common.isModeSwipe = false;
        this.getScroll(0);
      } else {
        if (!this.showOnboardings) this.easeOut(1);
      }
    } else {
      switch (window.orientation) {
        case 0:
          this.screenH = screen.height;
          this.screenW = screen.width;
          break;

        case 180:
          this.screenH = screen.height;
          this.screenW = screen.width;
          break;

        case -90:
          this.$store.state.common.isModeSwipe = false;
          this.getScroll(0);
          this.screenH = screen.width;
          this.screenW = screen.height;
          break;

        case 90:
          this.$store.state.common.isModeSwipe = false;
          this.getScroll(0);
          this.screenH = screen.width;
          this.screenW = screen.height;
          break;
      }
    }
    let imgArr = JSON.parse(localStorage.getItem("homePageImages"));
    if (imgArr != null) {
      if (!this.$store.state.common.isbottomMenuOpen) {
        this.$store.state.common.isModeSwipe = imgArr.isModeSwipe;
      }
      this.$store.state.hello.filteredImagesArr = imgArr.filteredImagesArr;
      if (this.finalUserLocation != "") {
        this.getLocation();
      }
      this.$store.state.hello.maxPhotos = imgArr.maxPhotos;
      this.swipeIndex = imgArr.swipeIndex;
      this.$forceUpdate();
    } else {
      let _q = vm.$route.query;
      let _qKeys = Object.keys(_q);
      //
      let _isCityKeyAvailable = false;
      if (_qKeys.includes(`loc`)) {
        _isCityKeyAvailable = true;
      }
      if (!_isCityKeyAvailable) {
        vm.$router.replace({
          path: `/`,
          query: {
            loc: `Berlin`,
          },
        });
      } else {
      }

      //
      // FUNCTION -> GET CITY ON BASIS OF QUERY/BERLIN.
      this.selectedCity = this.$route.query.loc;
    }
    //
    setTimeout(() => {
      //
      if (this.$route.query.loc !== vm.selectedCity) {
        vm.selectedCity = this.$route.query.loc;
      }
      //
    }, 100);
    //
    this.os = identifyOS();
    this.desktop = identifyDesktop();
    this.browser = isChrome();
  },
  //
};
</script>
<style scoped lang="scss">
//IMPORTED HOMEPAGE SCSS FOR STYLES
@import "../assets/scss/homepage/homepage";
</style>



// WEBPACK FOOTER //
// Hello.vue?3f8154f1